<template>
  <div class="planilha">
    <div style="position: fixed; top: 10px; z-index: 9000; right: 30px">
      <Filtro @exportar="exportar">
        <template slot="body">
          <div class="select-div">
            <label for="">Microrregião</label>
            <select v-model="filtro.microrregiao">
              <option :value="null">Todas</option>
              <option v-for="(c, i) in microrregiao" :key="i" :value="i">
                {{ c }}
              </option>
            </select>
          </div>
          <div class="select-div">
            <label for="">Mesorregião</label>
            <select v-model="filtro.mesorregiao">
              <option :value="null">Todas</option>
              <option v-for="(c, i) in mesorregiao" :key="i" :value="i">
                {{ c }}
              </option>
            </select>
          </div>
          <div class="select-multiple-div">
            <label for="">Cidade</label>
            <select v-model="filtro.cidade" multiple>
              <option :value="null">Todas</option>
              <option v-for="(c, i) in cidades" :key="i" :value="c.id">
                {{ c.nome }}
              </option>
            </select>
          </div>
        </template>
      </Filtro>
    </div>
    <div class="table-responsive-modern">
      <table class="table table-modern" style="white-space: nowrap;">
        <thead>
        <tr>
          <th style="text-align: center; text-transform: none; letter-spacing: normal; color: #94a3b8 !important;" :colspan="3 + kpi.length">
            Clique nos cabeçalhos para ordenar
          </th>
        </tr>
        <tr>
          <th>Nº</th>
          <th @click="ordem('nome_cidade', false)">Cidade</th>
          <th @click="ordem('competitividade', false)">Competitividade (%)</th>
          <th @click="ordem(k, true)" v-for="(k, i) in kpi" :key="i">
            <span>{{ k.nome }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(a, i) in analiseFiltrada" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ a.nome_cidade }}</td>
          <td>{{ (a.competitividade * 100).toFixed(2).replace(".", ",") }}%</td>
          <td v-for="(k, i) in kpi" :key="i">{{ getFaixa(k, a, true) }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import Filtro from "../Filtro.vue";
export default {
  components: {
    Filtro,
  },
  props: ["kpisinit", "analiseinit"],
  data() {
    return {
      kpi: this.kpisinit,
      analise: this.analiseinit,
      ordenar: {
        coluna: null,
        crescente: true,
      },
      filtro: {
        cidade: [],
        mesorregiao: null,
        microrregiao: null
      },
    };
  },
  computed: {
    cidades() {
      var c = [];
      for (const d of this.analise) {
        c.push({ id: d.cidade_id, nome: d.nome_cidade });
      }
      return c;
    },
    microrregiao() {
      var c = {};
      for (const d of this.analise) {
        c[d.codigo_microrregiao] = d.nome_microrregiao;
      }
      return c;
    },
    mesorregiao() {
      var c = {};
      for (const d of this.analise) {
        c[d.codigo_mesorregiao] = d.nome_mesorregiao;
      }
      return c;
    },
    analiseFiltrada() {
      var des = [];
      for (const d of this.analise) {
        var micro = this.filtro.microrregiao == null || d.codigo_microrregiao == this.filtro.microrregiao;
        var meso = this.filtro.mesorregiao == null || d.codigo_mesorregiao == this.filtro.mesorregiao;
        var cidade = true;
        
        if ( this.filtro.cidade.length > 0 ) {
          cidade = false;
          for ( const c of this.filtro.cidade ) {
            if ( c == null || d.cidade_id == c ) {
              cidade = true;
            }
          }
        }

        if (micro && meso && cidade) {
          des.push(d);
        }
      }
      return des;
    },
  },
  methods: {
    exportar() {
      var json = [];
      json.push({
        1: "Cidade",
        2: "Competitividade",
        3: "População adulta e idosa",
        4: "Produto interno bruto per capita (R$ 1,00)",
        5: "Verticalização urbana",
        6: "Número de empresas atuantes",
        7: "Salário médio mensal (R$)",
        8: "IDHM",
        9: "Veículos per capita",
        10: "Tarifa com ICMS",
        11: "Irradiação",
        12: "Percentual da população com ensino superior completo",
      });
      for (const d of this.analiseFiltrada) {
        var ob = {
          1: d.nome_cidade,
          2: (d.competitividade * 100).toFixed(2).replace(".", ","),
        };
        for (const key in this.kpi) {
          ob[parseInt(key) + 3] = this.getFaixa(this.kpi[key], d, true);
        }
        json.push(ob);
      }
      PLANILHA.export("Analise", "xlsx", json);
    },
    ordem(col, isKpi) {
      this.ordenar.coluna = col;
      this.ordenar.crescente = !this.ordenar.crescente;
      if (this.ordenar.coluna) {
        this.analise.sort((a, b) => {
          if (isKpi) {
            var va = this.getFaixa(col, a, false);
            var vb = this.getFaixa(col, b, false);
          } else {
            var va = a[this.ordenar.coluna];
            var vb = b[this.ordenar.coluna];
          }

          if (isNaN(va) || isNaN(vb)) {
            if (va == vb) {
              return 0;
            }
            if (this.ordenar.crescente) {
              if (va > vb) {
                return 1;
              } else {
                return -1;
              }
            } else {
              if (va > vb) {
                return -1;
              } else {
                return 1;
              }
            }
          } else {
            if (this.ordenar.crescente) {
              return va - vb;
            } else {
              return vb - va;
            }
          }
        });
      }
      this.$forceUpdate();
    },
    getFaixa(k, a, formatar) {
      var faixas = JSON.parse(a.faixas);

      if (faixas) {
        for (const faixa of faixas) {
          if (faixa.kpi == k.id) {
            if (formatar) {
              return (faixa.valor * 100).toFixed(2).replace(".", ",") + "%";
            } else {
              return faixa.valor;
            }
          }
        }
      }

      return "-";
    },
  },
};
</script>

<style>
th {
  cursor: pointer;
}
</style>